import { render, staticRenderFns } from "./ResFeeders.vue?vue&type=template&id=c1c46e76&scoped=true"
import script from "./ResFeeders.vue?vue&type=script&lang=js"
export * from "./ResFeeders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c46e76",
  null
  
)

export default component.exports